import React from 'react';
import PropTypes from 'prop-types';
import { palette, Td, Icon } from '@m12s/component-library';
import { P } from 'components/Text';
import { Cell, Tag } from 'components/Table';
import { angleRight } from 'lib/icons';

const ActivityTypeRow = ({
  activityType,
  activityModes,
  disabled,
  onClick,
}) => {
  return (
    <>
      <Td
        onClick={onClick(activityType, disabled)}
        interactive
        disabled={disabled}
      >
        <Cell>
          <P bold>{activityType.name}</P>
        </Cell>
      </Td>
      <Td
        onClick={onClick(activityType, disabled)}
        interactive
        disabled={disabled}
      >
        <Cell>
          <Tag color={activityModes[activityType.activityMode].color}>
            {activityModes[activityType.activityMode].name}
          </Tag>
        </Cell>
      </Td>
      <Td
        onClick={onClick(activityType, disabled)}
        interactive
        disabled={disabled}
      >
        <Cell>
          <Icon icon={angleRight} size="1.25rem" color={palette.Grey400} />
        </Cell>
      </Td>
    </>
  );
};

ActivityTypeRow.propTypes = {
  activityType: PropTypes.shape({
    name: PropTypes.string.isRequired,
    activityMode: PropTypes.string.isRequired,
    activityTypeRef: PropTypes.number.isRequired,
  }).isRequired,
  activityModes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export { ActivityTypeRow };
